import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'
import TabsLayout from '../views/TabsLayout.vue'
import { useAuthStore } from '~/stores/auth'
import { useAppStore } from '~/stores/app'
import { canAccessRoute, roleHome } from './access'

// The app shell (TabsLayout) is the parent route; each screen is a child
// rendered inside its <ion-router-outlet>. This is the idiomatic Ionic tabs
// structure and keeps the shell mounted across in-app navigation.
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: TabsLayout,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('../views/IndexPage.vue'),
      },
      {
        path: 'kitchen',
        name: 'kitchen',
        component: () => import('../views/KitchenPage.vue'),
      },
      {
        path: 'stock',
        name: 'stock',
        component: () => import('../views/Stock/StockPage.vue'),
      },
      {
        path: 'in-house',
        name: 'in-house',
        component: () => import('../views/InHousePage.vue'),
      },
      {
        path: 'tasks',
        name: 'tasks',
        component: () => import('../views/Tasks/TasksPage.vue'),
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('../views/Settings/SettingsPage.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

// Role/feature access control. The auth gate (no session) is handled by the
// shell (the outlet only mounts once authenticated), so here we only enforce
// which authenticated role may see which screen, and send the index to a home.
router.beforeEach((to) => {
  const AuthStore = useAuthStore()

  // Not yet ready: the app routes aren't mounted anyway — let navigation pass.
  if (!AuthStore.isUserAuthenticated) return true

  const role = AuthStore.reactiveUser?.profile?.role
  if (!role) return true

  const storefront = useAppStore().selectedStorefront

  if (to.name === 'index') {
    const home = roleHome(role, storefront)

    return home ? { name: home } : true
  }

  if (!canAccessRoute(String(to.name), role, storefront)) {
    const home = roleHome(role, storefront)

    return home ? { name: home } : { name: 'index' }
  }

  return true
})

export default router
